import { deleteEmptyObjects } from "utils";

export const QUICK_LOOK_PARAM = "book";
export const catalogueRoute = (location) => {
	const params = new URLSearchParams(location.search);
	params.delete(QUICK_LOOK_PARAM);
	return location.pathname + (params.toString() ? `?${params}` : "") + location.hash;
};

export const PRICING_OPTIONS = [
	{ value: "sellable", label: "Purchase only" },
	{ value: "subscription", label: "Subscription only" },
	{ value: "free", label: "Free books" },
	{ value: "all", label: "Purchase and subscription" },
];

export const FORMAT_OPTIONS = [
	{ value: "digital", label: "Digital" },
	{ value: "physical", label: "Physical" },
	{ value: "both", label: "Digital and physical" },
];

export const AVAILABILITY_OPTIONS = [
	{ value: "in_stock", label: "In stock" },
	{ value: "all", label: "All" },
];

const splitMulti = (value) => (value ? String(value).split("*").filter(Boolean) : []);

const joinMulti = (value) => (Array.isArray(value) ? value.filter(Boolean).join("*") : value || "");

const readParam = (params, key) => params.get(key) || "";

export const filtersFromSearch = (search = "") => {
	const raw = search.startsWith("?") ? search.slice(1) : search;
	const params = new URLSearchParams(raw);

	return {
		categoryIs: readParam(params, "category_is"),
		genreIs: readParam(params, "genre_is"),
		tagIs: readParam(params, "tag_is"),
		publisherIs: readParam(params, "publisher_is"),
		pricingModelIs: readParam(params, "pricing_model_is"),
		searchTerm: readParam(params, "search_term"),
		countryIs: readParam(params, "country_is"),
		publicationDateFrom: readParam(params, "publication_date_from"),
		publicationDateTo: readParam(params, "publication_date_to"),
		priceMin: readParam(params, "price_min"),
		priceMax: readParam(params, "price_max"),
		format: readParam(params, "format"),
		availability: readParam(params, "availability"),
		pageCountMin: readParam(params, "page_count_min"),
		pageCountMax: readParam(params, "page_count_max"),
		language: readParam(params, "language"),
	};
};

export const emptyDraft = () => ({
	searchTerm: "",
	categoryIs: "",
	genreIs: [],
	tagIs: [],
	publisherIs: "",
	pricingModelIs: "",
	countryIs: "",
	publicationDateFrom: "",
	publicationDateTo: "",
	priceMin: "",
	priceMax: "",
	format: "",
	availability: "",
	pageCountMin: "",
	pageCountMax: "",
	language: "",
});

export const draftFromSearch = (search = "") => {
	const filters = filtersFromSearch(search);

	return {
		searchTerm: filters.searchTerm,
		categoryIs: filters.categoryIs,
		genreIs: splitMulti(filters.genreIs),
		tagIs: splitMulti(filters.tagIs),
		publisherIs: filters.publisherIs,
		pricingModelIs: filters.pricingModelIs,
		countryIs: filters.countryIs,
		publicationDateFrom: filters.publicationDateFrom,
		publicationDateTo: filters.publicationDateTo,
		priceMin: filters.priceMin,
		priceMax: filters.priceMax,
		format: filters.format,
		availability: filters.availability,
		pageCountMin: filters.pageCountMin,
		pageCountMax: filters.pageCountMax,
		language: filters.language,
	};
};

const isFilled = (value) => {
	if (Array.isArray(value)) return value.some(Boolean);
	return value !== undefined && value !== null && String(value) !== "";
};

export const countActiveFilters = (filters = {}) =>
	[
		filters.searchTerm,
		filters.categoryIs,
		filters.genreIs,
		filters.tagIs,
		filters.publisherIs,
		filters.pricingModelIs,
		filters.countryIs,
		filters.publicationDateFrom,
		filters.publicationDateTo,
		filters.priceMin,
		filters.priceMax,
		filters.format,
		filters.availability,
		filters.pageCountMin,
		filters.pageCountMax,
		filters.language,
	].filter(isFilled).length;

export const cleanFilterParams = (data = {}) => {
	const cleaned = deleteEmptyObjects({ ...data });
	delete cleaned.open_filters;
	delete cleaned.focus_search_input;
	delete cleaned.page;
	delete cleaned.first_page;
	delete cleaned.rows;
	delete cleaned[QUICK_LOOK_PARAM];
	return cleaned;
};

export const booksResultsPath = (data = {}) => {
	const query = new URLSearchParams(cleanFilterParams(data)).toString();
	return query ? `/books?${query}` : "/books";
};

export const filtersPagePath = (search = "") => {
	const raw = search.startsWith("?") ? search.slice(1) : search;
	const params = new URLSearchParams(raw);
	params.delete("open_filters");
	params.delete("page");
	params.delete("first_page");
	params.delete("rows");
	params.delete(QUICK_LOOK_PARAM);
	const query = params.toString();
	return query ? `/books/filters?${query}` : "/books/filters";
};

export const appliedBooksPath = (draft) =>
	booksResultsPath({
		search_term: draft.searchTerm,
		category_is: draft.categoryIs,
		genre_is: joinMulti(draft.genreIs),
		tag_is: joinMulti(draft.tagIs),
		publisher_is: draft.publisherIs,
		pricing_model_is: draft.pricingModelIs,
		country_is: draft.countryIs,
		publication_date_from: draft.publicationDateFrom,
		publication_date_to: draft.publicationDateTo,
		price_min: draft.priceMin,
		price_max: draft.priceMax,
		format: draft.format,
		availability: draft.availability,
		page_count_min: draft.pageCountMin,
		page_count_max: draft.pageCountMax,
		language: draft.language,
	});

export const booksResultsPathFromSearch = (search = "") => {
	const raw = search.startsWith("?") ? search.slice(1) : search;
	const params = new URLSearchParams(raw);
	params.delete("page");
	params.delete("first_page");
	params.delete("rows");
	params.delete("open_filters");
	params.delete(QUICK_LOOK_PARAM);
	const query = params.toString();
	return query ? `/books?${query}` : "/books";
};
